// extracted by mini-css-extract-plugin
var _1 = "container-n_CAW";
var _2 = "facebook-Gab44";
var _3 = "follow-WUkKu";
var _4 = "hidden-yck1M";
var _5 = "instagram-LwaCe";
var _6 = "links-xiQRs";
var _7 = "logo-DgDX0";
var _8 = "subscribe-YPFcv";
var _9 = "tiktok-Ilkej";
var _a = "title-_5A2A";
var _b = "visible-e7R70";
var _c = "wrapper-taOKM";
export { _1 as "container", _2 as "facebook", _3 as "follow", _4 as "hidden", _5 as "instagram", _6 as "links", _7 as "logo", _8 as "subscribe", _9 as "tiktok", _a as "title", _b as "visible", _c as "wrapper" }
